import {
  HttpBackend,
  HttpClient,
  HttpEvent,
  HttpEventType,
} from '@angular/common/http';
import { DOCUMENT, Inject, Injectable } from '@angular/core';
import { Observable, catchError, filter, map, mergeMap, of, tap } from 'rxjs';
import { IFileProgressEvent } from '../../../shared/services/filestore.service';

@Injectable()
export class TranscriptChunkDownloadService {
  private httpNoAuth = new HttpClient(this.httpBackend);

  constructor(
    private httpBackend: HttpBackend,
    private http: HttpClient,
    @Inject(DOCUMENT) private document: Document
  ) {}

  downloadFile(fileKey: string, fileName: string) {
    return this.getTemporaryDownloadUrl(fileKey).pipe(
      mergeMap((getUrl) => this.download(getUrl, fileName))
    );
  }

  private getTemporaryDownloadUrl(fileKey: string): Observable<string> {
    return this.http.get('/transcripts/chunks/download', {
      params: { fileKey },
      responseType: 'text',
    });
  }

  private download(
    url: string,
    fileName: string
  ): Observable<IFileProgressEvent> {
    return this.httpNoAuth
      .get(url, {
        responseType: 'blob',
        reportProgress: true,
        observe: 'events',
      })
      .pipe(
        filter((event) => event.type !== HttpEventType.ResponseHeader),
        tap((t) => {
          if (t.type === HttpEventType.Response) {
            const a = this.document.createElement('a');
            a.href = URL.createObjectURL(t.body);
            a.setAttribute('download', fileName);
            a.click();
          }
        }),
        map((event) => this.getProgressEvent(event, fileName)),
        catchError(() => this.handleError(fileName))
      );
  }

  private getProgressEvent(
    event: HttpEvent<unknown>,
    fileName: string
  ): IFileProgressEvent {
    switch (event.type) {
      case HttpEventType.Sent:
        return {
          fileName,
          percentageComplete: 0,
          status: 'started',
        };

      case HttpEventType.DownloadProgress:
      case HttpEventType.UploadProgress:
        return {
          fileName,
          percentageComplete: Math.round((100 * event.loaded) / event.total),
          status: 'ongoing',
        };

      case HttpEventType.Response:
        return {
          fileName,
          percentageComplete: 100,
          status: 'complete',
        };
    }
  }

  private handleError(fileName: string): Observable<IFileProgressEvent> {
    return of({
      fileName,
      percentageComplete: 0,
      status: 'failed',
    });
  }
}
